<template>
  <Chart>
    <ChartTooltip :render="'renderTooltip'">
      <template v-slot:renderTooltip="{ props }">
        <div v-if="props">
          {{ props.point.category }} : {{ props.point.value }}
        </div>
      </template>
    </ChartTooltip>
    <ChartSeries>
      <ChartSeriesItem
        :type="'donut'"
        :data-items="dataItems"
        :category-field="'tenantName'"
        :field="selectedProduct == 'VTS' ? 'numberOfVehicle': 'totalEmployees'"
        :holeSize="90"
      >
        <ChartSeriesLabels
          :background="'none'"
          :font="'12'"
          :content="labelContent"
          :position="'outsideEnd'"
        />
      </ChartSeriesItem>
    </ChartSeries>
    <ChartLegend :visible="false" />
  </Chart>
</template>
<script>
import {Chart,ChartLegend,ChartSeries,ChartSeriesItem,ChartSeriesLabels, ChartTooltip} from "@progress/kendo-vue-charts";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapActions, mapMutations, mapState } = createNamespacedHelpers("dashboard");

const labelContent = (e) => e.category + " : " + e.value;

export default {
  components: {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesLabels,
    ChartTooltip
  },
  data: function () {
    return {
      labelContent: labelContent,
    };
  },
  props: {
    selectedProduct: String
  },
  computed: {
    dataItems() {
      return this.selectedProduct == 'VTS' ? this.$store.getters["dashboard/getTenantVehicles"] : this.$store.getters["dashboard/getTenantEmployees"]  
    }
  },
  methods: {
    ...mapState(["currentYear"]),
    ...mapActions(["getTenantDetailsOnProductName"]),
    ...mapMutations(["getNoOfVehicles","getNoOfEmployees"]),
    ...mapGetters(["getTenantVehicles","getTenantEmployees"]),
    getDataOnLoad() {
      this.$store.dispatch("dashboard/getTenantDetailsOnProductName", this.selectedProduct);
    },
  },
  mounted() {
    this.getDataOnLoad();
  }
};
</script>